import styled, { keyframes, css } from 'styled-components'
import * as React from 'react';

import {
  // Box,
  Button,
  CalculateIcon,
  Flex,
  HelpIcon,
  Link,
  LinkExternal,
  MetamaskIcon,
  Skeleton,
  Tag,
  Text,
  TimerIcon,
  useTooltip,
} from '@pancakeswap/uikit'
// import { BASE_BSC_SCAN_URL } from 'config'
// import { getBscScanLink } from 'utils'
// import { useCurrentBlock } from 'state/block/hooks'
// import { useVaultPoolByKey, useVaultPools } from 'state/pools/hooks'
// import { CompoundingPoolTag, ManualPoolTag } from 'components/Tags'
// import { getAddress, getVaultPoolAddress } from 'utils/addressHelpers'
// import { BIG_ZERO } from 'utils/bigNumber'
// import { registerToken } from 'utils/wallet'
// import { getBalanceNumber } from 'utils/formatBalance'
// import { convertSharesToCake, getPoolBlockInfo } from 'views/Pools/helpers'
// import { vaultPoolConfig } from 'config/constants/pools'
// import Harvest from './Harvest'
// import Stake from './Stake'
// import Apr from '../../Apr'
import AutoHarvest from './AutoHarvest'
import Stake from './Stake'
// import MaxStakeRow from '../../MaxStakeRow'
import EndBlocks from '../../PoolsTable/Cells/EndBlocks'
import { Box, IconButton, Tooltip } from '@mui/material'
import TotalStakedCell from '../Cells/TotalStakedCell'
import Balance from 'components/Balance'
import Apr from '../../Apr'
import AprRow from '../../PoolCard/AprRow'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useLocation } from 'react-router-dom'
import { CellContent } from '../Cells/BaseCell'
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import LiquidityModal from '../../Modal/LiquidityModal'
import { setIdx } from "store/IndexSlice";
import { useDispatch } from "react-redux"



const expandAnimation = keyframes`
  from {
    max-height: 0px;
  }
  to {
    max-height: 700px;
  }
`

const PLinkExternal = styled(LinkExternal)`
  text-decoration : none;
`

const collapseAnimation = keyframes`
  from {
    max-height: 700px;
  }
  to {
    max-height: 0px;
  }
`

const StyledActionPanel = styled.div`

  overflow: hidden;
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  padding: 12px;

  ${({ theme }) => theme.mediaQueries.lg} {
    flex-direction: row;
    padding: 16px 32px;
  }
  /* ${({ theme }) => theme.mediaQueries.md} {
    flex-direction: row;
    padding: 16px 32px;
  }
  ${({ theme }) => theme.mediaQueries.md} {
    flex-direction: row;
    padding: 16px 32px;
  } */

`
export const ActionContainer = styled.div<{ isAutoVault?: boolean }>`
  padding: 16px;
  border: 2px solid #00FED9;
  border-radius: 16px;
  flex-grow: 1;
  flex-basis: 0;
  margin-bottom: 16px;

  ${({ theme }) => theme.mediaQueries.sm} {
    margin-left: 12px;
    margin-right: 12px;
    margin-bottom: 0;
    height: auto;
  }
`;
export const ActionTitles = styled.div`
  font-weight: 600;
  font-size: 12px;
`

type MediaBreakpoints = {
  isXs: boolean
  isSm: boolean
  isMd: boolean
  isLg: boolean
  isXl: boolean
  isXxl: boolean
}

interface ActionPanelProps {
  account: string
  pool: any
  index?: any
  userDataLoaded: boolean
  expanded: boolean
  breakpoints: MediaBreakpoints,
  price: number
}

const InfoSection = styled(Box)`
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: auto;
  padding: 8px 8px;
  ${({ theme }) => theme.mediaQueries.lg} {
    padding: 0;
    flex-basis: 230px;
  }`

const RequirementSection = styled(Box)`
  display: flex;
  justify-content: space-between;

  
`

const AutoTag = styled.div`
    align-items: center;
    border-radius: 16px;
    display: inline-flex;
    font-weight: 400;
    white-space: nowrap;
    height: 28px;
    padding: 0 8px;
    font-size: 14px;
    color: black;
    background: #00FED9;
    border: 2px solid #31D0AA;

`

const GetButton = styled(Button)`
  align-items: center;
  border: 0px none;
  border-radius: 16px;
  box-shadow: rgba(14, 14, 44, 0.4) 0px -1px 0px 0px inset;
  display: inline-flex;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  -moz-box-pack: center;
  justify-content: center;
  letter-spacing: 0.03em;
  line-height: 1;
  opacity: 1;
  outline: currentcolor none 0px;
  transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
  height: 48px;
  background-color: #00FED9;
  color: black;
  margin-bottom: 10px;
  height: auto;
  font-size: 11px;
  padding: 5px 10px;

`
export const ActionContent = styled.div`
  display: flex;
  margin-top: 8px;
  justify-content: space-between;
  align-items: center;
`

const ActionPanel: React.FC<ActionPanelProps> = ({ pool, index, expanded, userDataLoaded, price }) => {
  const {
    sousId,
    stakingToken,
    earningToken,
    totalStaked,
    startBlock,
    endBlock,
    stakingLimit,
    stakingLimitEndBlock,
    contractAddress,
    userData,
    vaultKey,
    profileRequirement,
    isFinished,
  } = pool

  // const [open, setOpen] = useState(false);
  const dispatch = useDispatch()
  const RoiCalculator = () => dispatch(setIdx(index));

  // const handleOpen = () => setOpen(true);
  // const handleClose = () => setOpen(false);

  return (

    <StyledActionPanel>
      <InfoSection>

        <>
          <Box sx={{ display: { xs: 'bloxk', sm: 'block', md: 'none', lg: 'none' } }}>
            {/* <AprRow pool={pool} /> */}
            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
              <Text fontSize="14px" color='white' textAlign="left">
                APR:
              </Text>
              <Flex height="20px" alignItems="center">
                <Balance
                  onClick={(e) => {
                    e.stopPropagation();
                    RoiCalculator()
                  }}
                  mt="4px"
                  color='white'
                  fontSize='16px'
                  decimals={2}
                  prefix=""
                  value={pool.apy}
                  unit={`%`}
                />

                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    RoiCalculator()
                  }}
                  variant="text"
                  width="20px"
                  height="20px"
                  padding="0px"
                  marginLeft="4px"
                >
                  <CalculateIcon color="#00FED9" width="20px" />
                </Button>

              </Flex>
            </Box>
          </Box>

          <Box sx={{ display: { xs: 'block', sm: 'block', md: 'block', xl: 'none' } }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
              <Text fontSize="14px" color='white' textAlign="left">
                Total staked:
              </Text>
              <Flex height="20px" alignItems="center">
                <Balance
                  mt="4px"
                  color='white'
                  fontSize='14px'
                  decimals={0}
                  prefix=""
                  value={pool.totalStaked}
                  unit={` ${pool.name}`}
                />
              </Flex>
            </Box>
            {/* <TotalStakedCell pool={pool} /> */}
          </Box>
          {/* <Box sx={{ display: 'block' }}> */}
          <Box sx={{ display: { xl: 'none' } }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1, mb: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Text fontSize="14px" color='white' textAlign="left">
                  Ends in:
                </Text>
              </Box>
              <Flex height="20px" alignItems="center">
                <Balance
                  mt="4px"
                  color='white'
                  fontSize='14px'
                  decimals={0}
                  prefix=""
                  value={pool.endsin}
                  unit={' blocks'}
                />
                <Box sx={{ mt: 1 }}>
                  <TimerIcon ml="4px" color="#00FED9" />
                </Box>
              </Flex>
            </Box>
            {/* <EndBlocks pool={pool} /> */}
          </Box>
          <Flex mb="8px" justifyContent={['flex-end', 'flex-end', 'flex-start']}>
            <PLinkExternal href={'https://bscscan.com/token/0x6db3972c6a5535708e7a4f7ad52f24d178d9a93e '} bold={false} color='#00FED9'>
              <Text fontSize="14px" color='white' >
                See Token Info
              </Text>
            </PLinkExternal>
          </Flex>
          <Flex mb="8px" justifyContent={['flex-end', 'flex-end', 'flex-start']}>
            <PLinkExternal href={'https://www.drivenecosystem.com/ '} color='#00FED9'>
              <Text fontSize="14px" color='white' >
                View Project Site
              </Text>
            </PLinkExternal>
          </Flex>
        </>
      </InfoSection>


      <Box sx={{ display: { xs: 'block', sm: 'flex', md: 'flex', lg: 'flex' }, width: '100%' }}>
        <ActionContainer isAutoVault>
          <AutoHarvest pool={pool} />
        </ActionContainer>
        <ActionContainer isAutoVault>
          <Stake pool={pool} price={price} />
        </ActionContainer>
      </Box >
    </StyledActionPanel>

  )
}

export default ActionPanel
